export default __webpack_public_path__ + "static/media/app.074ce97d.svg";